import { useTranslation } from "react-i18next";
import HandleVideoChange from '../Components/HandleVideoChange';
import HandlePhotoChange from '../Components/HandlePhotoChange';
import HandleSoundChange from '../Components/HandleSoundChange';
import { useAuth } from '../../../../../../../context/AuthContext';

const AddContentQuestion = (props) => {
    const { user } = useAuth();

    const { t } = useTranslation()

    const handlePhotoChange = async (event) => {
        if (props.videoPath) {
            alert("Video olan bir soruya resim ekleyemezsiniz. Önce videoyu siliniz.");
            event.target.value = ""; // Inputu temizle
            return;
        }
        if (event.target.type === "textarea") {
            props.setImagePath(event.target.value)
        }
        else if (event.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', event.target.files[0]);
            await HandlePhotoChange(formData, user.token, props.setImagePath, props.setMsg)
        }
    }
    const handleVideoChange = async (event) => {
        if (props.imagePath || props.soundPath) {
            alert("Resim veya ses olan bir soruya video ekleyemezsiniz. Önce diğer medyaları siliniz.");
            event.target.value = "";
            return;
        }
        if (event.target.type === "textarea") {
            props.setVideoPath(event.target.value)
        }
        else if (event.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', event.target.files[0]);
            await HandleVideoChange(formData, user.token, props.setVideoPath, props.setMsg)
        }
    }

    const handleSoundChange = async (event) => {
        if (props.videoPath) {
            alert("Video olan bir soruya ses ekleyemezsiniz. Önce videoyu siliniz.");
            event.target.value = "";
            return;
        }
        if (event.target.type === "textarea") {
            props.setSoundPath(event.target.value)
        }
        else if (event.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', event.target.files[0]);
            await HandleSoundChange(formData, user.token, props.setSoundPath, props.setMsg)
        }
    }

    const deleteImage = async (event) => {
        props.setImagePath();
        document.getElementById("addphoto").value = "";
        alert("Resim Silindi!")
    }
    const deleteVideo = async (event) => {
        props.setVideoPath();
        document.getElementById("addvideo").value = "";
        alert("Video Silindi!")
    }
    const deleteSound = async (event) => {
        props.setSoundPath();
        document.getElementById("addsound").value = "";
        alert("Ses Silindi!")
    }

    return (


        <div class="accordion accordion-flush" id="accordionFlushExample" style={{ backgroundColor: "gray" }}>
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        <h4>{t('addFile')}</h4> <i>video ve resimler için minumum 1280*720 önerilir.</i>
                    </button>
                </h2>
                <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ backgroundColor: "white" }}>
                    <br />
                    <b>Dikkat: Çoklu medyayüklemede düzenleme aktif olmamaktadır!</b>

                    <div className="row" style={{ padding: "1%" }}>
                        {/* RESİM ÖN İZLEME */}
                        <div className="col-md-4">
                            <div className="mb-1">
                                <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handlePhotoChange} id="addphoto" name="addphoto" />
                            </div>
                            <div className="mb-1">
                                <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                <textarea className="form-control" rows={1} type="text" onChange={handlePhotoChange} id="addphotos" name="addphotos" />
                            </div>

                            {/* Ön İzleme Alanı */}
                            {props.imagePath && (
                                <div className="mt-2 text-center">
                                    <img src={props.imagePath} alt="Önizleme" style={{ maxWidth: "100%", maxHeight: "150px", borderRadius: "8px", border: "1px solid #ddd" }} />
                                    <br />
                                    <button className='btn btn-danger btn-sm mt-2' onClick={deleteImage}>Resmi Sil</button>
                                </div>
                            )}
                        </div>

                        {/* VİDEO ÖN İZLEME */}
                        <div className="col-md-4">
                            <div className="mb-1">
                                <label htmlFor="addvideo" className="form-label">{t("addVideo")}</label>
                                <input className="form-control" type="file" accept='video/*' onChange={handleVideoChange} id="addvideo" name="addvideo" />
                            </div>
                            <div className="mb-1">
                                <label htmlFor="addvideos" className="form-label">{t("addVideobyUrl")}</label>
                                <textarea className="form-control" rows={1} type="text" onChange={handleVideoChange} id="addvideos" name="addvideos" />
                            </div>

                            {/* Ön İzleme Alanı */}
                            {props.videoPath && (
                                <div className="mt-2 text-center">
                                    <video src={props.videoPath} controls style={{ maxWidth: "100%", maxHeight: "150px", controls: "True" }} />
                                    <br />
                                    <button className='btn btn-danger btn-sm mt-2' onClick={deleteVideo}>Video Sil</button>
                                </div>
                            )}
                        </div>

                        {/* SES ÖN İZLEME */}
                        <div className="col-md-4">
                            <div className="mb-1">
                                <label htmlFor="addsound" className="form-label">{t("addSound")}</label>
                                <input className="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={handleSoundChange} id="addsound" name="addsound" />
                            </div>
                            <div className="mb-1">
                                <label htmlFor="addsounds" className="form-label">{t("addSoundbyUrl")}</label>
                                <textarea className="form-control" rows={1} type="text" onChange={handleSoundChange} id="addsounds" name="addsounds" />
                            </div>

                            {/* Ön İzleme Alanı */}
                            {props.soundPath && (
                                <div className="mt-2 text-center">
                                    <audio src={props.soundPath} controls style={{ width: "100%" }} />
                                    <br />
                                    <button className='btn btn-danger btn-sm mt-2' onClick={deleteSound}>Sesi Sil</button>
                                </div>
                            )}
                        </div>

                    </div>
                    <br />
                </div>

            </div>
            <br />

        </div>



    );
};

export default AddContentQuestion;